<template>
    <component :is="icon" />
    <!-- class="icon" :style="{height: height + 'px'}" v-bind="$attrs" -->
</template>

<script>
import HandFinger from "@/components/icons/HandFinger.vue";
import Message from "@/components/icons/Message.vue";
import FileDownload from "@/components/icons/FileDownload.vue";
import School from "@/components/icons/School.vue";
import User from "@/components/icons/User.vue";
import Users from "@/components/icons/Users.vue";
import PlayerFirst from "@/components/icons/PlayerFirst.vue";
import PlayerLast from "@/components/icons/PlayerLast.vue";
import PlayerNext from "@/components/icons/PlayerNext.vue";
import PlayerPrev from "@/components/icons/PlayerPrev.vue";
import ArrowUp from "@/components/icons/ArrowUp.vue";
import ArrowDown from "@/components/icons/ArrowDown.vue";
import QuestionMark from "@/components/icons/QuestionMark.vue";
import Mail from "@/components/icons/Mail.vue";
import ChevronDown from "@/components/icons/ChevronDown.vue";
import ChevronDownWhite from "@/components/icons/ChevronDownWhite.vue";
import Search from "@/components/icons/Search.vue";
import Edit from "@/components/icons/Edit.vue";
import Phone from "@/components/icons/Phone.vue";
import Plus from "@/components/icons/Plus.vue";
import MagnifyingGlass from "@/components/icons/MagnifyingGlass.vue";
import Pointer from "@/components/icons/Pointer.vue";
import Calendar from "@/components/icons/Calendar.vue";
import Filter from "@/components/icons/Filter.vue";
import Pickup from "@/components/icons/Pickup.vue";
import DeliveryMan from "@/components/icons/DeliveryMan.vue";
import DeliveryMan2 from "@/components/icons/DeliveryMan2.vue";
import Truck from "@/components/icons/Truck.vue";
import UserPicture from "@/components/icons/UserPicture.vue";
import Snow from "@/components/icons/Snow.vue";
import True from "@/components/icons/True.vue";
import False from "@/components/icons/False.vue";
import Language from "@/components/icons/Language.vue";
import Logout from "@/components/icons/Logout.vue";
import Upload from "@/components/icons/Upload.vue";
import Info from "@/components/icons/Info.vue";
import Bin from "@/components/icons/Bin.vue";
import UserPlus from "@/components/icons/UserPlus.vue";
import Tags from "@/components/icons/Tags.vue";
import Menu from "@/components/icons/Menu.vue";
import Download from "@/components/icons/Download.vue";
import Resize from "@/components/icons/Resize.vue";
import Chart from "./icons/Chart.vue";
import CalendarNav from "./icons/CalendarNav.vue";
import Contacts from "./icons/Contacts.vue";
import Copy from "./icons/Copy.vue";
import Delete from "./icons/Delete.vue";
import See from "@/components/icons/See.vue";
import Exports from "@/components/icons/Exports.vue";
import Settings from "@/components/icons/Settings.vue";

export default {
    name: "icon",
    // inheritAttrs: false,
    props: {
        icon: {type: String, required: true},
        // width: {type: Number, required: false, default: 24},
        // height: {type: Number, required: false, default: 24}
    },
    components: {
        PlayerFirst,
        PlayerLast,
        PlayerNext,
        PlayerPrev,
        HandFinger,
        Message,
        FileDownload,
        School,
        User,
        Users,
        ArrowUp,
        ArrowDown,
        QuestionMark,
        Mail,
        ChevronDown,
        ChevronDownWhite,
        Search,
        Edit,
        Phone,
        Plus,
        MagnifyingGlass,
        Pointer,
        Calendar,
        Filter,
        Pickup,
        DeliveryMan,
        DeliveryMan2,
        Truck,
        UserPicture,
        Snow,
        True,
        False,
        Language,
        Logout,
        Upload,
        Info,
        Bin,
        UserPlus,
        Tags,
        Menu,
        Download,
        Resize,
        Chart,
        CalendarNav,
        Contacts,
        Copy,
        Delete,
        See,
        Exports,
        Settings
    }
}
</script>

<style lang="scss" scoped>
    .icon {
        display: inline-block;
        vertical-align: middle;
        align-items: center;    /* Vertical centering */
    }
</style>